export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/sr.2f27ecee.svg","height":504,"width":756,"blurWidth":0,"blurHeight":0};